import React from 'react';
import PropTypes from 'prop-types';
import { Provider as ModalPortalContextProvider } from './modal-portal';
import Hotkeys from '../../components/modal-portal/authed-hotkeys';

export const AuthedModalPortalContextProvider = ({ children }) => {
  return <ModalPortalContextProvider hotkeyValue={{ Hotkeys }}>{children}</ModalPortalContextProvider>;
};

AuthedModalPortalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
